<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <div class="grid md:gap-x-6 lg:gap-x-8 grid-cols-1 md:grid-cols-2">
                    <ChangeBeforeAfter
                        v-if="showBlock.mopCH"
                        title="繳別"
                    >
                        <template #before>
                            <div class="text-right md:text-left">
                                {{ before.mopCH }}
                            </div>
                        </template>
                        <template #after>
                            <div class="text-right md:text-left">
                                {{ after.mopCH }}
                            </div>
                        </template>
                    </ChangeBeforeAfter>
                    <ChangeBeforeAfter
                        v-if="showBlock.premium"
                        title="目標/計畫/每期保費"
                    >
                        <template #before>
                            <div class="text-right">
                                {{ addComma(before.premium) }}
                            </div>
                        </template>
                        <template #after>
                            <div class="text-right">
                                {{ addComma(after.premium) }}
                            </div>
                        </template>
                    </ChangeBeforeAfter>
                </div>

                <ChangeBeforeAfter
                    v-if="showBlock.goalPremList"
                    title="配置比例"
                >
                    <template #before>
                        <ul class="divide-dashed divide-y -mr-2.5 md:-mr-4">
                            <li
                                v-for="(item, index) in before.goalPremList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0"
                            >
                                <div class="md:mr-4 w-4/5 flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <template #after>
                        <ul class="divide-dashed divide-y -mr-2.5 md:-mr-4">
                            <li
                                v-for="(item, index) in after.goalPremList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0"
                            >
                                <div class="md:mr-4 w-4/5 flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { addComma } from '@/utils/number/addComma';
import { makeSort } from '@/utils/array/makeSort';

export default {
    name: 'A1Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('A1');
        const removeService = () => {
            emit('removeService', code.value);
        };
        const after = computed(() => data.value.after);
        const before = computed(() => data.value.before);
        /** 比對變更前後 只出現有變更的資料 */
        const showBlock = computed(() => {
            let goalPremListChange = false;
            if (after.value.goalPremList.length === before.value.goalPremList.length) {
                const afterlist = makeSort(after.value.goalPremList, 'fundCode');
                const beforelist = makeSort(before.value.goalPremList, 'fundCode');
                goalPremListChange = JSON.stringify(afterlist) !== JSON.stringify(beforelist);
            } else {
                goalPremListChange = true;
            }
            const change = {
                premium: after.value.premium !== before.value.premium,
                mopCH: after.value.mopCH !== before.value.mopCH,
                goalPremList: goalPremListChange,
            };
            return change;
        });
        // const makeSort = (ary, field) => {
        //     if (ary.length > 0) {
        //         ary.sort((a, b) => {
        //             return a[field] - b[field];
        //         });
        //         return ary;
        //     } else return [];
        // };
        return {
            code,
            showBlock,
            data,
            after,
            before,
            removeService,
            addComma,
        };
    },
};
</script>
<style lang="scss" scoped>
.dashed {
    @apply pt-1 pb-1 first:pt-0 last:pb-0.5;
}
</style>
